import { render, staticRenderFns } from "./UsdtTransfer.vue?vue&type=template&id=31be42ec&scoped=true"
import script from "./UsdtTransfer.vue?vue&type=script&lang=js"
export * from "./UsdtTransfer.vue?vue&type=script&lang=js"
import style0 from "./UsdtTransfer.vue?vue&type=style&index=0&id=31be42ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31be42ec",
  null
  
)

export default component.exports